import { Notice } from 'hb-react/shared/components/Notice';

import { Braintree } from '../components/Braintree';
import PaymentFakeGateway from '../components/FakeGateway';
import { Paypal } from '../components/Paypal';
import Stripe from '../components/Stripe';
import { Touchnet } from '../components/Touchnet';
import { PAYMENT_GATEWAY_TYPES } from '../constants';
import { usePaymentContext } from '../context/PaymentContext';

export const Gateway = () => {
  const { paymentAccountConfig } = usePaymentContext();

  if (paymentAccountConfig.type === PAYMENT_GATEWAY_TYPES.PAYPAL) {
    return <Paypal />;
  }

  if (paymentAccountConfig.type === PAYMENT_GATEWAY_TYPES.STRIPE) {
    return <Stripe />;
  }

  if (paymentAccountConfig.type === PAYMENT_GATEWAY_TYPES.TOUCHNET) {
    return <Touchnet />;
  }

  if (paymentAccountConfig.type === PAYMENT_GATEWAY_TYPES.BRAINTREE) {
    return <Braintree />;
  }

  if (paymentAccountConfig.type === PAYMENT_GATEWAY_TYPES.FAKE_GATEWAY) {
    return <PaymentFakeGateway />;
  }

  return (
    <Notice>
      {__('Unsupported payment method, please contact administrator')}
    </Notice>
  );
};
